module.exports = __webpack_public_path__ + "img/icon_inhouse.8360ee0e.svg";